<template>
	<div v-if="list.length" class="flex flex-wrap gap-1.5">
		<div
			v-for="item of list"
			:key="item.day"
			class="bg-secondary inline-flex max-w-full flex-wrap items-center gap-x-1.5 gap-y-0.5 rounded-md px-2 py-1 text-xs"
		>
			<span class="font-semibold capitalize">
				{{ $t(`common.calendar.days.${item.day}`) }}
			</span>
			<template v-for="(hours, index) of item.schedule" :key="index">
				<span class="text-tertiary">·</span>
				<span class="text-secondary tabular-nums">{{ hours.from }}–{{ hours.to }}</span>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { WorkSchedule } from "@/types/offices"
import { computed } from "vue"
import { WEEK_DAYS } from "@/const"

const { workSchedule } = defineProps<{ workSchedule: Partial<WorkSchedule> }>()

const list = computed(() =>
	WEEK_DAYS.filter(day => workSchedule[day]?.length).map(day => ({ day, schedule: workSchedule[day]! }))
)
</script>
